// MB-I18N-2A — os FR (extrait de LanguageContext, valeurs inchangées).
export default {
  "os.nav.group.pilotage": "Workspace",
  "os.nav.group.offer": "Mon offre",
  "os.nav.group.sales": "Mes ventes",
  "os.nav.group.clients": "Mes clients",
  "os.nav.group.communication": "Communication clients",
  "os.nav.group.operations": "Mon exploitation",
  "os.nav.group.purchasing": "Achats",
  "os.nav.item.supplier_invoices": "Factures fournisseurs",
  "os.nav.group.team": "Mon équipe",
  "os.nav.group.reports": "Rapports & conformité",
  "os.nav.group.config": "Configuration",
  "os.nav.item.overview": "Vue d'ensemble",
  "os.nav.item.establishments": "Établissements",
  "os.nav.item.products": "Produits",
  "os.nav.item.recipes": "Recettes",
  "os.nav.item.orders": "Commandes",
  "os.nav.item.sales": "Ventes",
  "os.nav.item.pos": "Caisse (POS)",
  "os.nav.item.loyalty": "Fidélité",
  "os.nav.item.rewards": "Récompenses",
  "os.nav.item.reviews": "Avis",
  "os.nav.item.wallet": "Wallet",
  "os.nav.item.news": "Actus",
  "os.nav.item.communication": "Communication clients",
  "os.nav.item.stock": "Stock",
  "os.nav.item.inventory": "Inventaire matière",
  "os.nav.item.ingredients": "Ingrédients",
  "os.nav.item.material_cost": "Coût matière",
  "os.nav.item.margins": "Marges",
  "os.nav.item.team": "Équipe",
  "os.nav.item.reports": "Rapports",
  "os.nav.item.closures": "Clôtures Z",
  "os.nav.item.compliance": "Conformité fiscale",
  "os.nav.item.shop": "Boutique",
  "os.nav.item.payments": "Paiements",
  "os.nav.item.subscription": "Abonnement",
  "os.nav.item.audit": "Audit Log",
  "os.nav.badge.soon": "Bientôt",
  "os.roadmap.eyebrow": "Sur la feuille de route",
  "os.roadmap.back": "Retour au tableau de bord",
  "os.roadmap.communication.title": "Communication clients",
  "os.roadmap.communication.desc": "Bientôt : campagnes, messages et automatisations pour fidéliser vos clients directement depuis SUPERKAWA OS.",
  "os.roadmap.wallet.title": "Wallet propriétaire",
  "os.roadmap.wallet.desc": "Bientôt : pilotez les soldes, recharges et transactions Wallet de vos clients depuis une vue dédiée.",
  "os.owner.eyebrow": "Vue d'ensemble",
  "os.owner.title": "Tous vos établissements",
  "os.owner.context.consolidated": "Consolidé",
  "os.owner.context.establishment": "Établissement",
  "os.owner.context.all_establishments": "Tous vos établissements",
  "os.owner.context.today": "Aujourd'hui :",
  "os.owner.context.orders_word": "commandes",
  "os.owner.context.no_critical": "aucune alerte critique",
  "os.owner.context.critical": "{n} alerte(s) critique(s)",
  "os.owner.kpi.avg_basket_hint": "aujourd'hui",
  "os.owner.kpi.avg_basket_hint_multi": "devise unique uniquement",
  "os.owner.kpi.customers": "Clients",
  "os.owner.kpi.customers_hint": "clients distincts",
  "os.owner.section.clients": "Clients",
  "os.owner.clients.reviews": "Avis",
  "os.owner.clients.reviews_select": "Choisir un établissement",
  "os.owner.clients.reviews_count": "{n} avis",
  "os.owner.clients.reviews_empty": "Aucun avis pour l'instant",
  "os.owner.insights.critical": "Critique",
  "os.owner.insights.important": "Important",
  "os.owner.insights.suggestion": "Suggestion",
  "os.owner.quick.title": "Actions rapides",
  "os.owner.quick.products": "Produits",
  "os.owner.quick.rewards": "Récompenses",
  "os.owner.quick.orders": "Commandes",
  "os.owner.quick.export": "Exporter",
  "os.owner.subtitle": "Vue consolidée de votre activité du jour.",
  "os.owner.kpi.orders": "Commandes",
  "os.owner.kpi.avg_basket": "Panier moyen",
  "os.owner.kpi.loyalty": "Clients fidélité actifs",
  "os.owner.kpi.wallets": "Wallets actifs",
  "os.owner.kpi.revenue": "CA aujourd'hui",
  "os.owner.kpi.revenue_hint": "aujourd'hui",
  "os.owner.kpi.revenue_hint_multi": "aujourd'hui · devises non additionnées",
  "os.owner.kpi.orders_hint": "aujourd'hui",
  "os.owner.kpi.loyalty_hint": "tous établissements",
  "os.owner.kpi.wallets_hint": "en circulation",
  "os.owner.revenue_by_currency": "CA par devise",
  "os.owner.multi_note": "Devises multiples — non additionnées",
  "os.owner.no_orders": "Aucune commande aujourd'hui pour le moment.",
  "os.owner.orders_singular": "commande",
  "os.owner.orders_plural": "commandes",
  "os.owner.establishments": "Vos établissements",
  "os.owner.card.revenue": "CA du jour",
  "os.owner.card.orders": "Commandes",
  "os.owner.card.avg_basket": "Panier moyen",
  "os.owner.card.customers": "Clients",
  "os.owner.card.loyalty": "Fidélité",
  "os.owner.card.wallets": "Wallets",
  "os.owner.status.active": "Actif",
  "os.owner.status.inactive": "Inactif",
  "os.owner.empty.title": "Aucun établissement",
  "os.owner.empty.desc": "Créez votre premier établissement pour voir vos chiffres consolidés ici.",
  "os.owner.empty.cta": "Créer mon établissement",
  "os.owner.error.title": "Impossible de charger vos données",
  "os.owner.error.desc": "Une erreur est survenue. Veuillez réessayer.",
  "os.owner.error.retry": "Réessayer",
  "os.owner.chart.title": "Évolution des ventes",
  "os.owner.chart.revenue": "Chiffre d'affaires",
  "os.owner.chart.orders": "Commandes",
  "os.owner.chart.today": "Aujourd'hui",
  "os.owner.chart.no_sale_today": "Aucune vente aujourd'hui",
  "os.owner.chart.empty_hint": "Les ventes s'afficheront ici dès la première commande.",
  "os.owner.chart.range7": "7 jours",
  "os.owner.chart.range30": "30 jours",
  "os.owner.chart.range90": "90 jours",
  "os.owner.kpi.revenue_label": "Chiffre d'affaires",
  "os.owner.kpi.revenue_hint_multi_short": "devises non additionnées",
  "os.owner.kpi.period.today": "Aujourd'hui",
  "os.owner.kpi.period.yesterday": "Hier",
  "os.owner.kpi.period.7d": "7 j",
  "os.owner.kpi.period.30d": "30 j",
  "os.owner.kpi.period.90d": "90 j",
  "os.owner.kpi.compare.new": "Nouveau",
  "os.owner.top_products.view_products": "Produits",
  "os.owner.top_products.view_categories": "Catégories",
  "os.owner.categories.empty_title": "Aucune catégorie vendue",
  "os.owner.categories.empty_desc": "Vos meilleures catégories apparaîtront ici dès la première vente encaissée.",
  "os.owner.categories.uncategorized": "Sans catégorie",
  "os.owner.ops.title": "Intelligence opérationnelle",
  "os.owner.ops.subtitle": "Comprendre votre activité pour décider",
  "os.owner.ops.range.7d": "7 j",
  "os.owner.ops.range.30d": "30 j",
  "os.owner.ops.range.90d": "90 j",
  "os.owner.ops.error": "Impossible de charger les indicateurs.",
  "os.owner.ops.retry": "Réessayer",
  "os.owner.ops.payments_title": "Répartition des paiements",
  "os.owner.ops.no_transactions": "Aucune transaction sur cette période.",
  "os.owner.ops.pay.card": "Carte",
  "os.owner.ops.pay.cash": "Espèces",
  "os.owner.ops.pay.wallet": "Wallet",
  "os.owner.ops.orders_title": "Évolution des commandes",
  "os.owner.ops.orders.today": "Aujourd'hui",
  "os.owner.ops.orders.7d": "7 derniers jours",
  "os.owner.ops.orders.30d": "30 derniers jours",
  "os.owner.ops.customers_title": "Clients",
  "os.owner.ops.customers_new": "Nouveaux",
  "os.owner.ops.customers_returning": "Récurrents",
  "os.owner.ops.customers_frequency": "Visites / client",
  "os.owner.ops.coverage": "Analyse basée sur {identified} commandes identifiées sur {total} ({pct} %).",
  "os.owner.ops.coverage_empty": "Aucune commande identifiée sur cette période.",
  "os.owner.temporal.title": "Analyse temporelle",
  "os.owner.temporal.subtitle": "Heures et jours de forte activité (90 j)",
  "os.owner.temporal.not_configured_title": "Fuseau horaire non configuré",
  "os.owner.temporal.not_configured_desc": "Configurez le fuseau horaire de votre établissement afin d'obtenir les analyses horaires.",
  "os.owner.temporal.no_data": "Pas encore assez de commandes payées pour analyser les heures et les jours.",
  "os.owner.temporal.error": "Impossible de charger l'analyse temporelle.",
  "os.owner.temporal.retry": "Réessayer",
  "os.owner.temporal.peak_hour": "Heure la plus forte",
  "os.owner.temporal.quiet_hour": "Heure la plus faible",
  "os.owner.temporal.best_day": "Jour le plus fort",
  "os.owner.temporal.worst_day": "Jour le plus faible",
  "os.owner.temporal.orders_count": "{count} commandes",
  "os.owner.temporal.hour_range": "{from} h – {to} h",
  "os.owner.temporal.coverage_partial": "{configured} établissement(s) analysé(s) · {unconfigured} sans fuseau exclu(s).",
  "os.owner.temporal.weekday.0": "Lundi",
  "os.owner.temporal.weekday.1": "Mardi",
  "os.owner.temporal.weekday.2": "Mercredi",
  "os.owner.temporal.weekday.3": "Jeudi",
  "os.owner.temporal.weekday.4": "Vendredi",
  "os.owner.temporal.weekday.5": "Samedi",
  "os.owner.temporal.weekday.6": "Dimanche",
  "os.owner.health.title": "Santé de l'établissement",
  "os.owner.health.subtitle": "Synthèse déterministe · boutique active",
  "os.owner.health.loading": "Calcul de la synthèse…",
  "os.owner.health.error": "Impossible de charger la synthèse.",
  "os.owner.health.retry": "Réessayer",
  "os.owner.health.score_label": "Score de santé",
  "os.owner.health.of_100": "/ 100",
  "os.owner.health.band.critical": "Critique",
  "os.owner.health.band.at_risk": "À risque",
  "os.owner.health.band.healthy": "Sain",
  "os.owner.health.band.strong": "Solide",
  "os.owner.health.coverage.complete": "Couverture complète",
  "os.owner.health.coverage.partial": "Couverture partielle",
  "os.owner.health.active_count": "{active}/{total} dimensions évaluées",
  "os.owner.health.no_shop_selected_title": "Aucune boutique sélectionnée",
  "os.owner.health.no_shop_selected_desc": "Sélectionnez un établissement pour afficher son score de santé.",
  "os.owner.health.insufficient_title": "Données insuffisantes pour un score fiable",
  "os.owner.health.insufficient_desc": "Il faut au moins {min} dimensions évaluables, dont la croissance ou la santé client. Voici ce qui manque :",
  "os.owner.health.dim.d1": "Croissance du CA",
  "os.owner.health.dim.d2": "Santé client",
  "os.owner.health.dim.d3": "Robustesse du menu",
  "os.owner.health.dim.d4": "Diversification des règlements",
  "os.owner.health.dim.d5": "Hygiène opérationnelle",
  "os.owner.health.reason.d1_insufficient": "Historique de ventes insuffisant pour mesurer la croissance.",
  "os.owner.health.reason.d2_insufficient_history": "Historique client trop court pour évaluer la rétention.",
  "os.owner.health.reason.d2_insufficient_sample": "Trop peu de clients identifiés pour évaluer la rétention.",
  "os.owner.health.reason.d3_insufficient_data": "Observation produit insuffisante pour évaluer le menu.",
  "os.owner.health.reason.d4_insufficient_sample": "Trop peu de règlements pour évaluer le mix de paiement.",
  "os.owner.health.reason.d5_not_applicable": "Module stock non activé pour cet établissement.",
  "os.owner.health.momentum.up": "CA en hausse de {pct} % sur 30 j",
  "os.owner.health.momentum.down": "CA en baisse de {pct} % sur 30 j",
  "os.owner.health.momentum.flat": "CA stable sur 30 j",
  "os.owner.health.strengths_label": "Points forts",
  "os.owner.health.risks_label": "Principaux risques",
  "os.owner.health.none": "Aucun signal notable.",

  "os.owner.reco.title": "Recommandations",
  "os.owner.reco.subtitle": "Que faire maintenant — priorité aux risques",
  "os.owner.reco.loading": "Analyse en cours…",
  "os.owner.reco.error": "Impossible de charger les recommandations.",
  "os.owner.reco.retry": "Réessayer",
  "os.owner.reco.empty_title": "Rien à signaler",
  "os.owner.reco.empty_desc": "Aucune action prioritaire détectée pour le moment. Tout semble sous contrôle.",
  "os.owner.reco.action_label": "Action",
  "os.owner.reco.severity.critical": "Critique",
  "os.owner.reco.severity.high": "Priorité haute",
  "os.owner.reco.severity.medium": "À surveiller",
  "os.owner.reco.severity.low": "Opportunité",
  "os.owner.reco.dead_observation": "Analyse des produits « poids morts » en cours : {pending} produit(s) en période d'observation ({days} j minimum) avant évaluation.",
  "os.owner.reco.menu.concentration.title": "Chiffre d'affaires concentré",
  "os.owner.reco.menu.concentration.desc": "Vos {count} meilleurs produits pèsent {pct} % du CA en {currency}. Une forte dépendance à quelques références.",
  "os.owner.reco.menu.concentration.action": "Sécurisez leur disponibilité et diversifiez les ventes.",
  "os.owner.reco.menu.star.title": "Produit moteur : {name}",
  "os.owner.reco.menu.star.desc": "{name} génère {pct} % du CA en {currency}. C'est un produit phare.",
  "os.owner.reco.menu.star.action": "Sécurisez son stock et mettez-le en avant.",
  "os.owner.reco.menu.dead.title": "Produit peu vendu : {name}",
  "os.owner.reco.menu.dead_zero.desc": "{name} n'a enregistré aucune vente sur 90 jours.",
  "os.owner.reco.menu.dead_low.desc": "{name} n'a vendu que {units} unité(s) sur 90 jours.",
  "os.owner.reco.menu.dead.action": "Envisagez de le retirer ou de le repositionner.",
  "os.owner.reco.customers.coverage_low.title": "Trop de commandes anonymes",
  "os.owner.reco.customers.coverage_low.desc": "Seules {pct} % de vos commandes sont rattachées à un client identifié. Vos analyses clients restent partielles.",
  "os.owner.reco.customers.coverage_low.action": "Incitez à l'identification via QR, Wallet ou fidélité à l'encaissement.",
  "os.owner.reco.customers.retention_low.title": "Rétention client faible",
  "os.owner.reco.customers.retention_low.desc": "Seuls {pct} % de vos clients identifiés reviennent. La fidélisation est à renforcer.",
  "os.owner.reco.customers.retention_low.action": "Activez fidélité, relance ou campagne de réachat ciblée.",
  "os.owner.reco.customers.frequency_low.title": "Fréquence d'achat faible",
  "os.owner.reco.customers.frequency_low.desc": "Vos clients identifiés achètent en moyenne {frequency} fois. Peu de visites répétées.",
  "os.owner.reco.customers.frequency_low.action": "Créez une mécanique de retour : fidélité ou offre ciblée.",
  "os.owner.reco.customers.loyal_base.title": "Base de clients fidèles",
  "os.owner.reco.customers.loyal_base.desc": "{pct} % de vos clients identifiés reviennent. Une base fidèle solide, votre meilleur actif.",
  "os.owner.reco.customers.loyal_base.action": "Protégez-la avec des avantages fidélité ciblés ; évitez les promotions trop agressives.",
  "os.owner.reco.payments.method.card": "carte",
  "os.owner.reco.payments.method.cash": "espèces",
  "os.owner.reco.payments.method.wallet": "Wallet",
  "os.owner.reco.payments.dependence.title": "Dépendance à un seul mode",
  "os.owner.reco.payments.dependence.desc": "Le mode « {method} » concentre {pct} % de vos règlements. Une panne ou un refus sur ce canal bloquerait l'encaissement.",
  "os.owner.reco.payments.dependence.action": "Diversifiez les moyens de paiement acceptés (carte, espèces, Wallet).",
  "os.owner.reco.payments.wallet_opportunity.title": "Potentiel Wallet inexploité",
  "os.owner.reco.payments.wallet_opportunity.desc": "Sur {orders} règlements, le Wallet ne pèse que {pct} %. Un volume suffisant pour en faire un vrai levier de fidélisation.",
  "os.owner.reco.payments.wallet_opportunity.action": "Lancez une campagne de recharge ou un bonus Wallet à l'encaissement.",
  "os.owner.reco.payments.wallet_low.title": "Adoption Wallet faible",
  "os.owner.reco.payments.wallet_low.desc": "Le Wallet ne représente que {pct} % de vos règlements. Son adoption reste marginale.",
  "os.owner.reco.payments.wallet_low.action": "Encouragez la recharge Wallet avec un bonus ou un avantage fidélité.",
  "os.owner.reco.payments.balanced.title": "Mix de paiement équilibré",
  "os.owner.reco.payments.balanced.desc": "Carte {card} %, espèces {cash} %, Wallet {wallet} % : une répartition saine qui limite votre dépendance à un seul canal.",
  "os.owner.reco.payments.balanced.action": "Préservez cette diversité et maintenez vos incitations Wallet.",
  "os.owner.reco.temporal.peak_hour_focus.title": "Heure de pointe : {hour} h",
  "os.owner.reco.temporal.peak_hour_focus.desc": "Le créneau de {hour} h enregistre {pct} % de commandes de plus que la moyenne de vos autres heures d'activité.",
  "os.owner.reco.temporal.peak_hour_focus.action": "Renforcez l'équipe, la préparation et la disponibilité des produits autour de {hour} h.",
  "os.owner.reco.temporal.weekday_dropoff.title": "Jour en retrait : {weekday}",
  "os.owner.reco.temporal.weekday_dropoff.desc": "Le {weekday}, vous enregistrez {pct} % de commandes de moins que la moyenne de vos autres jours.",
  "os.owner.reco.temporal.weekday_dropoff.action": "Testez une animation, une offre ciblée ou une campagne fidélité le {weekday}.",
  "os.owner.reco.temporal.quiet_hour_activation.title": "Heure creuse : {hour} h",
  "os.owner.reco.temporal.quiet_hour_activation.desc": "Le créneau de {hour} h reste {pct} % sous la moyenne de vos heures d'activité.",
  "os.owner.reco.temporal.quiet_hour_activation.action": "Activez une offre creux, une campagne Wallet ou un avantage fidélité vers {hour} h.",
  "os.owner.reco.temporal.best_weekday_leverage.title": "Jour fort : {weekday}",
  "os.owner.reco.temporal.best_weekday_leverage.desc": "Le {weekday} génère {pct} % de commandes de plus que la moyenne de vos autres jours.",
  "os.owner.reco.temporal.best_weekday_leverage.action": "Identifiez ce qui fait la force du {weekday} et reproduisez-le sur vos autres jours.",

  "os.owner.chart.empty": "Aucune vente sur cette période.",
  "os.owner.chart.error": "Impossible de charger le graphique.",
  "os.owner.sales_by_store.title": "Ventes par établissement",
  "os.owner.sales_by_store.empty": "Aucune vente à répartir aujourd'hui.",
  "os.owner.top_products.title": "Top produits",
  "os.owner.top_products.tab_sales": "Ventes",
  "os.owner.top_products.tab_qty": "Quantités",
  "os.owner.top_products.qty_unit": "vendus",
  "os.owner.top_products.empty": "Aucune vente produit pour le moment.",
  "os.owner.top_products.empty_title": "Aucune vente aujourd'hui",
  "os.owner.top_products.empty_desc": "Vos meilleures ventes apparaîtront ici dès la première commande encaissée.",
  "os.owner.header.today": "Aujourd'hui",
  "os.owner.header.export": "Exporter",
  "os.owner.header.add_establishment": "Ajouter un établissement",
  "os.owner.header.soon": "Bientôt disponible",
  "os.nav.item.ws_team": "Équipe",
  "os.team.title": "Équipe Workspace",
  "os.team.subtitle": "Invitez des collaborateurs et gérez leurs accès aux établissements.",
  "os.team.invite_cta": "Inviter un membre",
  "os.team.search_placeholder": "Rechercher par nom, email ou boutique…",
  "os.team.search_no_results": "Aucun résultat pour cette recherche.",
  "os.team.loading": "Chargement de l'équipe…",
  "os.team.error": "Impossible de charger l'équipe. Réessayez.",
  "os.team.retry": "Réessayer",
  "os.team.no_shops": "Aucun établissement",
  "os.team.role.manager": "Manager",
  "os.team.role.member": "Membre",
  "os.team.role.owner": "Propriétaire",
  "os.team.status.pending": "En attente",
  "os.team.status.active": "Actif",
  "os.team.modal.title": "Inviter un membre",
  "os.team.modal.description": "Le collaborateur recevra un email pour créer son compte et accéder aux établissements sélectionnés.",
  "os.team.modal.email_label": "Email",
  "os.team.modal.email_placeholder": "collaborateur@email.com",
  "os.team.modal.name_label": "Nom (optionnel)",
  "os.team.modal.name_placeholder": "Nom du collaborateur",
  "os.team.modal.role_label": "Rôle",
  "os.team.modal.shops_label": "Établissements",
  "os.team.modal.shops_empty": "Aucun établissement disponible.",
  "os.team.modal.submit": "Envoyer l'invitation",
  "os.team.modal.sending": "Envoi…",
  "os.team.modal.cancel": "Annuler",
  "os.team.modal.err_email": "Adresse email invalide.",
  "os.team.modal.err_shops": "Sélectionnez au moins un établissement.",
  "os.team.modal.success": "Invitation envoyée.",
  "os.team.modal.error": "Impossible d'envoyer l'invitation.",
  "os.team.pending.title": "Invitations en attente",
  "os.team.pending.empty": "Aucune invitation en attente.",
  "os.team.pending.col_email": "Email",
  "os.team.pending.col_role": "Rôle",
  "os.team.pending.col_shops": "Boutiques",
  "os.team.pending.col_date": "Date",
  "os.team.pending.col_status": "Statut",
  "os.team.pending.col_actions": "Actions",
  "os.team.pending.cancel": "Annuler",
  "os.team.pending.cancelled": "Invitation annulée.",
  "os.team.pending.cancel_error": "Impossible d'annuler l'invitation.",
  "os.team.members.title": "Membres actifs",
  "os.team.members.empty": "Aucun membre actif pour le moment.",
  "os.team.members.col_name": "Nom",
  "os.team.members.col_email": "Email",
  "os.team.members.col_role": "Rôle",
  "os.team.members.col_shops": "Boutiques",
  "os.team.members.col_last_login": "Dernière connexion",
  "os.team.members.col_actions": "Actions",
  "os.team.members.view": "Voir",
  "os.team.members.never": "—",
  "os.team.member_detail.title": "Détail du membre",
  "os.team.member_detail.close": "Fermer",
  "os.team.member_detail.status": "Statut",
  "os.team.member_detail.joined": "Membre depuis",
  "os.team.member_detail.primary_owner": "Propriétaire principal",
  "os.team.member_detail.primary_owner_note": "Le propriétaire principal ne peut pas être modifié ni retiré.",
  "os.team.member_detail.edit_stores": "Modifier les accès",
  "os.team.member_detail.remove": "Retirer de l'Organization",
  "os.team.edit_stores.title": "Modifier les accès",
  "os.team.edit_stores.description": "Sélectionnez les établissements auxquels {name} a accès dans cet espace de travail.",
  "os.team.edit_stores.shops_empty": "Aucun établissement disponible.",
  "os.team.edit_stores.save": "Enregistrer",
  "os.team.edit_stores.saving": "Enregistrement…",
  "os.team.edit_stores.cancel": "Annuler",
  "os.team.edit_stores.success": "Accès mis à jour.",
  "os.team.edit_stores.error": "Impossible de mettre à jour les accès.",
  "os.team.remove.title": "Retirer ce membre ?",
  "os.team.remove.description": "{name} n'aura plus accès aux établissements de cet espace de travail. Ses accès à d'autres espaces de travail et son compte restent intacts.",
  "os.team.remove.confirm": "Retirer le membre",
  "os.team.remove.removing": "Retrait…",
  "os.team.remove.cancel": "Annuler",
  "os.team.remove.success": "Membre retiré de l'espace de travail.",
  "os.team.remove.error": "Impossible de retirer le membre.",
  "os.nav.item.ws_cockpit": "Tableau de bord",
  "os.nav.item.dashboard": "Tableau de bord",
  "os.nav.item.consolidated": "Vue consolidée",
  "os.nav.item.ws_settings": "Paramètres",
  "os.nav.item.ws_account": "Mon compte",
  "os.wss.title": "Paramètres du Workspace",
  "os.wss.subtitle": "Informations légales et préférences communes à tous vos établissements.",
  "os.wss.workspace_label": "Workspace",
  "os.wss.loading": "Chargement des paramètres…",
  "os.wss.error": "Impossible de charger les paramètres. Réessayez.",
  "os.wss.retry": "Réessayer",
  "os.wss.save": "Enregistrer les modifications",
  "os.wss.saving": "Enregistrement…",
  "os.wss.cancel": "Annuler",
  "os.wss.save_success": "Paramètres enregistrés.",
  "os.wss.save_error": "Impossible d'enregistrer les paramètres.",
  "os.wss.unsaved": "Modifications non enregistrées",
  "os.wss.general.title": "Informations générales",
  "os.wss.general.desc": "Identité de votre espace de travail.",
  "os.wss.general.name": "Nom de l'Organization",
  "os.wss.general.name_ph": "Ex. SUPERKAWA Group",
  "os.wss.general.description": "Description",
  "os.wss.general.description_ph": "Décrivez votre activité (optionnel)",
  "os.wss.general.logo": "Logo",
  "os.wss.general.logo_ph": "URL du logo (https://…)",
  "os.wss.general.logo_hint": "Collez l'URL d'une image. L'hébergement avancé arrivera plus tard.",
  "os.wss.general.country": "Pays principal",
  "os.wss.general.language": "Langue par défaut",
  "os.wss.general.timezone": "Fuseau horaire",
  "os.wss.legal.title": "Informations légales",
  "os.wss.legal.desc": "Utilisées pour vos documents officiels. Compatibles international.",
  "os.wss.legal.legal_name": "Raison sociale",
  "os.wss.legal.commercial_name": "Nom commercial",
  "os.wss.legal.registration_number": "N° d'immatriculation (SIREN/SIRET ou équivalent)",
  "os.wss.legal.vat_number": "N° de TVA",
  "os.wss.legal.address": "Adresse",
  "os.wss.legal.city": "Ville",
  "os.wss.legal.postal_code": "Code postal",
  "os.wss.legal.country": "Pays d'enregistrement de l'organisation",
  "os.wss.legal.country_hint": "Ce paramètre concerne l'entité légale, pas le pays de vos établissements.",
  "os.wss.prefs.title": "Préférences",
  "os.wss.prefs.desc": "Affichage et régionalisation.",
  "os.wss.prefs.date_format": "Format de date",
  "os.wss.prefs.first_day": "Premier jour de semaine",
  "os.wss.prefs.first_day.monday": "Lundi",
  "os.wss.prefs.first_day.sunday": "Dimanche",
  "os.wss.lang.fr": "Français",
  "os.wss.lang.en": "Anglais",
  "os.wss.placeholder_optional": "Optionnel",
  "os.wss.none": "—",
  "os.ws.subtitle": "Vue consolidée de tous vos établissements.",
  "os.ws.counts.establishments": "Établissements",
  "os.ws.counts.members": "Membres",
  "os.ws.counts.pending_invitations": "Invitations en attente",
  "os.ws.cta.add_establishment": "Ajouter un établissement",
  "os.ws.cta.team": "Équipe",
  "os.ws.kpi.title": "Indicateurs consolidés",
  "os.ws.kpi.revenue": "CA consolidé",
  "os.ws.kpi.orders": "Commandes",
  "os.ws.kpi.customers": "Clients",
  "os.ws.kpi.wallet": "Wallet",
  "os.ws.kpi.points": "Points distribués",
  "os.ws.kpi.reviews": "Avis",
  "os.ws.kpi.coming_soon": "À venir",
  "os.ws.kpi.reviews_summary": "{count} avis · {avg}/5",
  "os.ws.kpi.reviews_none": "Aucun avis",
  "os.ws.stores.title": "Établissements",
  "os.ws.stores.open_cockpit": "Ouvrir le cockpit",
  "os.ws.stores.today_revenue": "CA aujourd'hui",
  "os.ws.stores.today_orders": "Commandes",
  "os.ws.stores.wallet": "Wallet",
  "os.ws.stores.status.active": "Ouvert",
  "os.ws.stores.status.inactive": "Fermé",
  "os.ws.stores.empty": "Aucun établissement pour le moment.",
  "os.est.title": "Établissements",
  "os.est.subtitle": "Gérez tous les établissements de votre espace de travail.",
  "os.est.search": "Rechercher par nom, pays ou devise…",
  "os.est.count": "{count} établissement(s)",
  "os.est.col.name": "Établissement",
  "os.est.col.country": "Pays",
  "os.est.col.currency": "Devise",
  "os.est.col.plan": "Plan",
  "os.est.col.status": "Statut",
  "os.est.col.revenue": "CA aujourd'hui",
  "os.est.col.orders": "Commandes",
  "os.est.col.wallet": "Wallet",
  "os.est.col.actions": "Actions",
  "os.est.empty_search": "Aucun établissement ne correspond à votre recherche.",
  "os.ws.activity.title": "Activité récente",
  "os.ws.activity.empty": "Aucune activité récente.",
  "os.ws.activity.invitation_created": "Nouvelle invitation",
  "os.ws.activity.invitation_accepted": "Invitation acceptée",
  "os.ws.activity.store_created": "Nouvel établissement",
  "os.ws.quick.title": "Actions rapides",
  "os.ws.quick.create_establishment": "Créer un établissement",
  "os.ws.quick.invite_member": "Inviter un membre",
  "os.ws.quick.view_team": "Voir l'équipe",
  "os.ws.quick.view_subscriptions": "Voir les abonnements",
  "os.ws.quick.soon": "Bientôt",
  "os.ws.loading": "Chargement du cockpit…",
  "os.ws.error": "Impossible de charger le cockpit. Réessayez.",
  "os.ws.retry": "Réessayer",
  "os.owner.establishments.active": "actifs",
  "os.owner.establishments.open": "Ouvert",
  "os.owner.establishments.add": "Ajouter un établissement",
  "os.owner.supervision.allclear_title": "Tout est sous contrôle",
  "os.owner.supervision.allclear_desc": "Aucune alerte sur vos {n} établissements",
  "os.owner.supervision.m_establishments": "Établissements actifs",
  "os.owner.supervision.m_orders": "Commandes aujourd'hui",
  "os.owner.supervision.m_loyalty": "Clients fidélité",
  "os.owner.supervision.m_wallets": "Wallets actifs",
  "os.owner.supervision.no_order_today": "Dernière commande — aucune aujourd'hui",
  "os.owner.supervision.orders_today": "{n} commande(s) aujourd'hui",
  "os.account.role.owner": "Propriétaire",
  "os.account.role.staff": "Équipe",
  "os.account.verified": "vérifié",
  "os.account.logout": "Déconnexion",
  "os.account.subscription": "Abonnement",
  "os.account.establishments_singular": "établissement actif",
  "os.account.establishments_plural": "établissements actifs",
  "os.account.manage": "Gérer",
  "os.account.help": "Aide & Support",
  "os.owner.alerts.title": "Alertes & Insights",
  "os.owner.alerts.empty": "Tout est sous contrôle. Aucune alerte.",
  "os.owner.alerts.rewards_unit": "en attente de validation",
  "os.owner.alerts.wallet_desc": "Aucune recharge depuis {days} j",
  "os.owner.alerts.loyalty_desc": "Aucun client fidélité actif",
  "os.owner.alerts.stock_out.title": "Rupture de stock",
  "os.owner.alerts.stock_low.title": "Stock faible",
  "os.owner.alerts.ingredient_out.title": "Rupture matière",
  "os.owner.alerts.ingredient_low.title": "Stock matière faible",
  "os.owner.alerts.rewards_pending.title": "Récompenses en attente",
  "os.owner.alerts.wallet_inactive.title": "Wallet inactif",
  "os.owner.alerts.loyalty_inactive.title": "Fidélité inactive",
  "os.owner.open_establishment": "Ouvrir l'établissement",
  "os.page.greeting_morning": "Bonjour",
  "os.page.greeting_afternoon": "Bon après-midi",
  "os.page.greeting_evening": "Bonsoir",
  "os.page.role_owner_fallback": "patron",
  "os.page.role_manager_fallback": "manager",
  "os.page.your_day": "Voici votre journée.",
  "os.page.view_client_menu": "Voir le menu client",
  "os.page.change_shop": "Changer",
  "os.page.kpi_revenue_today": "CA aujourd'hui",
  "os.page.kpi_orders": "Commandes",
  "os.page.kpi_pending": "En attente",
  "os.page.payments_title": "Encaissement du jour",
  "os.page.pay_wallet": "Wallet",
  "os.page.pay_cash": "Espèces",
  "os.page.pay_card": "CB (TPE)",
  "os.page.pay_total": "Total",
  "os.page.pay_op_singular": "opération",
  "os.page.pay_op_plural": "opérations",
  "os.page.badge_card": "CB",
  "os.page.badge_cash": "Cash",
  "os.page.badge_wallet": "Wallet",
  "os.page.alerts_title": "Actions à traiter",
  "os.page.alert_rewards_singular": "1 récompense à valider",
  "os.page.alert_rewards_plural": "{count} récompenses à valider",
  "os.page.alert_paused": "Boutique en pause",
  "os.page.alert_queue": "{count} commandes en attente",
  "os.page.onboarding_complete": "Tout est prêt — votre établissement est opérationnel.",
  "os.page.onboarding_hide": "Masquer",
  "os.page.onboarding_title": "Votre établissement est créé",
  "os.page.onboarding_subtitle": "Voici les prochaines étapes pour le rendre opérationnel.",
  "os.page.onboarding_done": "Fait",
  "os.page.step_add_products_title": "Ajoutez vos premiers produits",
  "os.page.step_add_products_desc": "Ajoutez les premiers produits que vos clients pourront acheter.",
  "os.page.step_add_products_cta": "Ajouter",
  "os.page.step_menu_title": "Organisez votre menu",
  "os.page.step_menu_desc_ready": "Organisez vos produits dans votre menu.",
  "os.page.step_menu_cta": "Définir mes prix",
  "os.page.step_rewards_title": "Configurez vos récompenses",
  "os.page.step_rewards_desc": "Créez votre premier avantage fidélité.",
  "os.page.step_rewards_cta": "Configurer",
  "os.page.step_pos_title": "Ouvrez la caisse",
  "os.page.step_pos_desc": "Ouvrez votre caisse pour commencer à encaisser.",
  "os.page.step_pos_cta": "Ouvrir le POS",
  "os.page.step_shop_title": "Votre boutique est prête",
  "os.page.step_shop_desc": "Nom, adresse, pays & devise.",
  "os.page.step_shop_cta": "Configurer",
  "os.page.step_products_title": "Définissez vos prix",
  "os.page.step_products_desc_draft_one": "{count} produit en brouillon — définissez vos tarifs pour ouvrir à la vente.",
  "os.page.step_products_desc_draft_many": "{count} produits en brouillon — définissez vos tarifs pour ouvrir à la vente.",
  "os.page.step_products_desc_ready": "Vos produits disposent désormais de tarifs configurés.",
  "os.page.step_products_cta": "Définir mes prix",
  "os.page.step_team_title": "Invitez votre équipe",
  "os.page.step_team_desc": "Créez un accès barista pour le POS.",
  "os.page.step_team_cta": "Inviter l'équipe",
  "os.page.step_sale_title": "Faites votre première vente",
  "os.page.step_sale_desc": "Effectuez une commande test afin de vérifier votre installation.",
  "os.page.step_sale_cta": "Ouvrir le POS",
  "os.page.step_sale_hint": "Une fois la caisse ouverte, réalisez une commande test pour terminer cette étape.",
  "os.page.nudge_plan_title": "Découvrez votre formule recommandée",
  "os.page.nudge_plan_desc": "START, PRO ou FULL selon vos besoins.",
  "os.page.nudge_plan_cta": "Voir les offres",
  "os.page.first_sale_title": "Vos produits sont prêts à la vente.",
  "os.page.first_sale_desc": "Prochaine étape : réalisez votre première vente test.",
  "os.page.first_sale_cta": "Ouvrir le POS",
  "os.page.quick_access": "Accès rapide",
  "os.page.quick_pos_title": "Ouvrir le POS",
  "os.page.quick_pos_desc": "Encaisser une commande",
  "os.page.activity_title": "Activité récente",
  "os.page.activity_see_all": "Tout voir",
  "os.page.activity_empty_title": "Aucune activité pour le moment",
  "os.page.activity_empty_desc": "La journée n'a pas encore commencé.",
  "os.page.activity_empty_cta": "Ouvrir le POS",
  "os.page.items_singular": "article",
  "os.page.items_plural": "articles",
  "os.page.creating_title": "Préparation de votre boutique…",
  "os.page.creating_desc": "Encore un instant — nous finalisons la mise en place de votre établissement.",
  "os.page.empty_create_title": "Créez votre premier établissement",
  "os.page.empty_select_title": "Sélectionnez votre boutique",
  "os.page.empty_create_subtitle": "Tout commence ici. En 30 secondes, votre boutique est prête à encaisser.",
  "os.page.empty_select_subtitle_one": "Vous avez {count} boutique configurée. Choisissez celle à piloter.",
  "os.page.empty_select_subtitle_many": "Vous avez {count} boutiques configurées. Choisissez celle à piloter.",
  "os.page.empty_create_cta": "Créer ma première boutique",
  "os.page.empty_open_shop": "Ouvrir {name}",
  "os.page.my_shop_fallback": "ma boutique",
  "os.shell.open_pos": "Ouvrir le POS",
  "os.shell.open_nav": "Ouvrir la navigation",
  "os.shell.close_nav": "Fermer la navigation",
  "os.shell.platform": "Plateforme",
  "os.shell.language": "Langue",
  "os.shell.language_fr": "Français",
  "os.shell.language_en": "English",
  "os.shell.all_establishments": "Tous les établissements",
  "os.sub.eyebrow": "Abonnement",
  "os.sub.title": "Choisissez votre offre SUPERKAWA OS",
  "os.sub.intro": "Une plateforme qui évolue avec votre établissement. Démarrez simplement, ajoutez les recettes puis la gestion des stocks quand vous êtes prêt.",
  "os.sub.status.active": "Abonnement actif",
  "os.sub.status.trial": "Période d'essai en cours",
  "os.sub.status.grace": "Période de grâce",
  "os.sub.status.expired": "Période d'essai expirée",
  "os.sub.status.default": "Statut de l'abonnement",
  "os.sub.status.your_shop": "Votre boutique",
  "os.sub.status.day": "jour",
  "os.sub.status.days": "jours",
  "os.sub.status.before_grace_end": "avant la fin de la grâce",
  "os.sub.status.remaining_one": "restant",
  "os.sub.status.remaining_many": "restants",
  "os.sub.period.monthly": "Mensuel",
  "os.sub.period.annual": "Annuel",
  "os.sub.period.two_months_free": "2 mois offerts",
  "os.sub.period.suffix_month": "mois",
  "os.sub.period.suffix_year": "an",
  "os.sub.recommended": "Recommandé",
  "os.sub.current_offer": "Offre actuelle",
  "os.sub.soon_available": "Bientôt disponible",
  "os.sub.redirecting": "Redirection…",
  "os.sub.subscribe": "S'abonner",
  "os.sub.pay_transfer": "Payer par virement bancaire",
  "os.sub.start.tagline": "L'essentiel pour encaisser et fidéliser.",
  "os.sub.pro.tagline": "Standardisez vos recettes Superkawa.",
  "os.sub.full.tagline": "L'exploitation complète, prête à scaler.",
  "os.sub.feat.client_app": "Application client",
  "os.sub.feat.pos": "POS encaissement",
  "os.sub.feat.wallet_loyalty": "Wallet & fidélité",
  "os.sub.feat.dashboard": "Dashboard SaaS",
  "os.sub.feat.recipes": "Recettes Superkawa",
  "os.sub.feat.stock_mgmt": "Gestion des stocks",
  "os.sub.feat.all_start": "Tout START",
  "os.sub.feat.all_pro": "Tout PRO",
  "os.sub.feat.material_cost": "Coût matière",
  "os.sub.feat.margins": "Marges",
  "os.sub.feat.ingredients_catalog": "Catalogue ingrédients",
  "os.sub.feat.stock": "Stock",
  "os.sub.feat.inventory": "Inventaire",
  "os.sub.feat.stock_alerts": "Alertes stock",
  "os.sub.loading": "Chargement des tarifs…",
  "os.sub.error": "Impossible de récupérer les tarifs pour le moment. Réessayez dans un instant.",
  "os.sub.soon_banner": "💳 Le paiement en ligne arrive très bientôt. En attendant, contactez-nous pour activer votre formule.",
  "os.sub.pricing_note": "Tarifs en euros (€), identiques pour tous les pays. L'annuel correspond à 10 mois (2 mois offerts).",
  "os.sub.contact_question": "Une question ? Contactez-nous",
  "os.sub.toast.cancelled": "Paiement annulé. Vous pouvez réessayer quand vous le souhaitez.",
  "os.sub.toast.paid": "Paiement reçu ✓ — l'activation de votre abonnement sera confirmée très prochainement.",
  "os.sub.toast.expired": "La session de paiement a expiré. Merci de réessayer.",
  "os.sub.toast.processing": "Paiement en cours de traitement. Vous recevrez une confirmation par email.",
  "os.sub.toast.select_shop": "Sélectionnez une boutique avant de vous abonner.",
  "os.sub.toast.checkout_error": "Impossible de démarrer le paiement. Réessayez dans un instant.",
  "os.saas.days_one": "{n} jour restant",
  "os.saas.days_many": "{n} jours restants",
  "os.saas.badge.trial": "Essai",
  "os.saas.badge.grace": "Grâce",
  "os.saas.badge.expired": "Expiré",
  "os.saas.badge.active": "Actif",
  "os.saas.badge.past_due": "Paiement en retard",
  "os.saas.trial.title_ending": "Votre période d'essai expire bientôt — {days}",
  "os.saas.trial.title_active": "Essai gratuit • {days}",
  "os.saas.trial.title_default": "Essai gratuit en cours",
  "os.saas.trial.desc": "Profitez de toutes les fonctionnalités. Choisissez votre offre pour continuer sans interruption.",
  "os.saas.trial.cta": "Voir les offres",
  "os.saas.grace.title_active": "Période de grâce active — {days}",
  "os.saas.grace.title_default": "Période de grâce active",
  "os.saas.grace.desc": "Votre essai est terminé. Activez une offre maintenant pour conserver l'accès complet.",
  "os.saas.grace.cta": "Activer une offre",
  "os.saas.expired.title": "Votre période d'essai a expiré",
  "os.saas.expired.desc": "Activez une offre pour réactiver toutes les fonctionnalités de SUPERKAWA OS.",
  "os.saas.expired.cta": "Activer une offre",
  "os.saas.past_due.title": "Votre dernier paiement a échoué",
  "os.saas.past_due.desc": "Votre accès reste actif pour le moment. Mettez à jour votre moyen de paiement pour éviter toute interruption.",
  "os.saas.past_due.cta": "Mettre à jour le paiement",
  "os.saas.suspended.status_paused": "suspendu",
  "os.saas.suspended.status_cancelled": "annulé",
  "os.saas.suspended.title": "Abonnement {status} — {name}",
  "os.saas.suspended.desc": "L'accès passera bientôt en lecture seule. Contactez SUPERKAWA pour réactiver votre abonnement.",
  "os.saas.gate.title_paused": "Abonnement suspendu",
  "os.saas.gate.title_cancelled": "Abonnement annulé",
  "os.saas.gate.title_expired": "Période d'essai expirée",
  "os.saas.gate.desc_expired": "Votre période d'essai (et le délai de grâce) est terminée. Activez une offre auprès de SUPERKAWA pour réactiver le POS, l'OS et la gestion.",
  "os.saas.gate.desc_default": "L'accès à cette boutique est temporairement bloqué. Régularisez votre abonnement auprès de SUPERKAWA pour réactiver le POS, l'OS et la gestion.",
  "os.saas.gate.contact": "Contacter SUPERKAWA",
  "os.saas.gate.switch_shop": "Changer de boutique",
  "os.virement.doc_title": "Paiement par virement bancaire — SUPERKAWA OS",
  "os.virement.meta_desc": "Réglez votre abonnement SUPERKAWA OS par virement bancaire. Activation sous 24 h ouvrées après réception du paiement.",
  "os.virement.hero_eyebrow": "Paiement par virement bancaire",
  "os.virement.hero_title": "Réglez votre abonnement par virement",
  "os.virement.hero_desc": "Vous préférez payer par virement bancaire plutôt que par carte ? C'est possible. Votre abonnement SUPERKAWA OS est activé manuellement dès réception de votre paiement.",
  "os.virement.selected_formule": "Formule sélectionnée : {formule}",
  "os.virement.coords_title": "Coordonnées bancaires",
  "os.virement.coords_loading": "Chargement des coordonnées…",
  "os.virement.coords_fallback": "Coordonnées bancaires transmises sur demande.",
  "os.virement.label_beneficiary": "Bénéficiaire",
  "os.virement.label_bank": "Banque",
  "os.virement.label_address": "Adresse",
  "os.virement.label_iban": "IBAN",
  "os.virement.label_bic": "BIC / SWIFT",
  "os.virement.copy": "Copier",
  "os.virement.copied": "Copié",
  "os.virement.copy_aria": "Copier {label}",
  "os.virement.toast_copied": "{label} copié",
  "os.virement.toast_copy_error": "Copie impossible. Sélectionnez le texte manuellement.",
  "os.virement.ref_title": "Référence obligatoire",
  "os.virement.ref_instruction": "Indiquez impérativement en référence de votre virement :",
  "os.virement.ref_value_with_formule": "Nom de l'établissement + formule {formule}",
  "os.virement.ref_value_default": "Nom de l'établissement + formule choisie",
  "os.virement.ref_example": "Exemple : Restaurant Le Palmier - PRO",
  "os.virement.delai_title": "Activation sous 24 h ouvrées",
  "os.virement.delai_desc": "Dès réception des fonds, votre abonnement est activé sous 24 heures ouvrées. Aucune activation automatique n'est effectuée tant que le virement n'est pas reçu.",
  "os.virement.steps_title": "Étapes",
  "os.virement.step_label": "Étape {n}",
  "os.virement.step1_title": "Effectuez votre virement bancaire",
  "os.virement.step1_desc": "Réalisez le virement depuis votre banque pour le montant de la formule choisie, en indiquant la référence ci-dessous.",
  "os.virement.step2_title": "Envoyez votre justificatif",
  "os.virement.step2_desc": "Transmettez votre preuve de virement à {email}.",
  "os.virement.step3_title": "Activation de votre abonnement",
  "os.virement.step3_desc": "Votre abonnement est activé sous 24 h ouvrées après réception des fonds.",
  "os.virement.cta_title": "Virement effectué ?",
  "os.virement.cta_desc": "Cliquez ci-dessous pour nous envoyer votre justificatif. Le message est pré-rempli : il ne vous reste plus qu'à joindre votre preuve de virement.",
  "os.virement.cta_done": "J'ai effectué mon virement",
  "os.virement.cta_back_formules": "Voir les formules",
  "os.virement.footer_cgv": "CGV",
  "os.virement.footer_privacy": "Confidentialité",
  "os.virement.footer_legal": "Mentions légales",
  "os.virement.mail_subject": "Justificatif de virement – SUPERKAWA",
  "os.virement.mail_body": "Bonjour,\n\nVeuillez trouver ci-joint mon justificatif de virement pour mon abonnement SUPERKAWA OS.\n\n- Nom de l'établissement : \n- Formule : {formule}\n- Date du virement : \n\nCordialement,",

  // MB-ACCOUNT-EXIT-1 — "Mon compte" (self-service manager/staff/barista)
  "os.account.title": "Mon compte",
  "os.account.subtitle": "Gérez votre appartenance aux organisations et votre compte SUPERKAWA.",
  "os.account.loading": "Chargement…",
  "os.account.error": "Impossible de charger vos informations. Réessayez.",
  "os.account.retry": "Réessayer",
  "os.account.memberships_title": "Mes organisations",
  "os.account.memberships_desc": "Les organisations auxquelles vous appartenez en tant que membre de l'équipe.",
  "os.account.role_manager": "Manager",
  "os.account.role_member": "Équipe",
  "os.account.role_owner": "Propriétaire",
  "os.account.leave_cta": "Quitter cette organisation",
  "os.account.leave_owner_note": "Vous êtes propriétaire de cette organisation. La sortie du propriétaire fera l'objet d'un futur flux de fermeture du compte professionnel.",
  "os.account.leave_confirm_title": "Quitter cette organisation ?",
  "os.account.leave_confirm_body": "Vous perdrez l'accès à cette entreprise et à ses boutiques. Votre compte SUPERKAWA restera actif si vous appartenez à une autre organisation.",
  "os.account.leave_confirm_cta": "Quitter",
  "os.account.leave_success": "Vous avez quitté cette organisation.",
  "os.account.leave_error": "Impossible de quitter cette organisation. Réessayez.",
  "os.account.danger_zone": "Zone de suppression",
  "os.account.delete_cta": "Supprimer mon compte SUPERKAWA",
  "os.account.delete_confirm_title": "Supprimer mon compte SUPERKAWA ?",
  "os.account.delete_confirm_body": "Vos accès professionnels seront supprimés de toutes les organisations auxquelles vous appartenez. Certaines traces historiques nécessaires à la sécurité, à l'audit ou aux obligations légales pourront être conservées sous un identifiant interne non directement identifiable.",
  "os.account.delete_confirm_cta": "Supprimer mon compte",
  "os.account.delete_success": "Votre compte SUPERKAWA a été supprimé. Vous allez être déconnecté.",
  "os.account.delete_error": "Impossible de supprimer votre compte. Réessayez.",
  "os.account.owner_reserved_title": "Actions propriétaire",
  "os.account.owner_reserved_desc": "En tant que propriétaire, les actions de sortie/suppression self-service manager/staff/barista ne s'appliquent pas à votre compte. Les actions suivantes seront disponibles dans un lot ultérieur :",
  "os.account.owner_cancel_subscription": "Résilier mon abonnement",
  "os.account.owner_close_store": "Fermer cette boutique",
  "os.account.owner_close_company": "Fermer mon compte professionnel SUPERKAWA",
  "os.account.owner_reserved_note": "Non disponible pour le moment.",
  "os.pay.return.title": "Retour de Stripe",
  "os.pay.return.notice": "Nous avons bien reçu votre retour depuis Stripe. Ce retour ne suffit pas à activer les paiements par carte : nous vérifions l'état de votre compte auprès de Stripe.",
  "os.pay.return.checking": "Vérification de l'état de votre compte…",
  "os.pay.return.retry": "Vérifier à nouveau",
  "os.pay.refresh.title": "Le lien d'activation n'est plus valide",
  "os.pay.refresh.notice": "Le lien Stripe a expiré, a déjà été utilisé ou n'a pas abouti. Aucun paiement n'est activé à ce stade. Demandez un nouveau lien pour reprendre l'activation.",
  "os.pay.refresh.cta": "Obtenir un nouveau lien",
  "os.pay.back": "Retour à la gestion",
  "os.pay.status.active": "Les paiements par carte sont actifs sur votre compte Stripe.",
  "os.pay.status.pending": "Votre compte est en cours de vérification par Stripe. Les paiements par carte ne sont pas encore actifs.",
  "os.pay.status.onboarding_required": "Des informations restent à fournir à Stripe. Les paiements par carte ne sont pas encore actifs.",
  "os.pay.status.restricted": "Votre compte Stripe est restreint. Les paiements par carte ne sont pas actifs.",
  "os.pay.err.owner_only": "Seul le propriétaire peut vérifier ou relancer l'activation des paiements.",
  "os.pay.err.not_found": "Compte de paiement introuvable.",
  "os.pay.err.unavailable": "Les paiements par carte ne sont pas disponibles pour le moment.",
  "os.pay.err.session": "Votre session a expiré. Reconnectez-vous puis réessayez.",
  "os.pay.err.invalid_link": "Lien de retour invalide.",
  "os.pay.err.generic": "Impossible de joindre le service de paiement. Réessayez dans un instant.",
  "os.pay.page.title": "Paiements clients",
  "os.pay.page.subtitle": "Encaissez vos clients par carte dans votre établissement.",
  "os.pay.page.loading": "Chargement des paiements…",
  "os.pay.page.country": "Pays",
  "os.pay.page.currency": "Devise",
  "os.pay.page.customers.title": "Paiements clients",
  "os.pay.page.customers.note": "Les paiements de vos clients sont versés directement sur votre compte : Superkawa ne les reçoit ni ne les conserve.",
  "os.pay.page.readonly": "Seul le propriétaire peut configurer les paiements.",
  "os.pay.page.action.configure": "Activer les paiements par carte",
  "os.pay.page.action.continue": "Continuer l'activation",
  "os.pay.page.action.refresh": "Actualiser l'état",
  "os.pay.page.no_shop.title": "Aucun établissement sélectionné",
  "os.pay.page.no_shop.desc": "Choisissez un établissement pour gérer ses paiements.",
  "os.pay.page.err.forbidden": "Vous n'avez pas accès aux paiements de cet établissement.",
  "os.pay.page.err.conflict": "L'état des paiements a changé. Actualisez la page puis réessayez.",
  "os.pay.page.status.unavailable.badge": "Indisponible",
  "os.pay.page.status.unavailable.desc": "Les paiements par carte ne peuvent pas être activés pour cet établissement.",
  "os.pay.page.status.not_configured.badge": "Non configuré",
  "os.pay.page.status.not_configured.desc": "Les paiements par carte ne sont pas encore activés pour cet établissement.",
  "os.pay.page.status.creating.badge": "Création en cours",
  "os.pay.page.status.creating.desc": "Votre compte de paiement est en cours de création.",
  "os.pay.page.status.onboarding_required.badge": "Informations requises",
  "os.pay.page.status.onboarding_required.desc": "Des informations sont à fournir auprès de notre partenaire de paiement pour activer les paiements par carte.",
  "os.pay.page.status.pending_verification.badge": "Vérification en cours",
  "os.pay.page.status.pending_verification.desc": "Vos informations sont en cours de vérification. Les paiements par carte ne sont pas encore actifs.",
  "os.pay.page.status.active.badge": "Actif",
  "os.pay.page.status.active.desc": "Les paiements par carte sont actifs pour cet établissement.",
  "os.pay.page.status.restricted.badge": "Restreint",
  "os.pay.page.status.restricted.desc": "Les paiements par carte ne sont pas encore actifs. Complétez les informations demandées par notre partenaire de paiement ou actualisez l'état.",
  "os.pay.page.status.error.badge": "À vérifier",
  "os.pay.page.status.error.desc": "L'état des paiements n'a pas pu être déterminé. Contactez le support si le problème persiste.",
  "os.pay.page.reason.market_unsupported": "Le pays de cet établissement n'est pas encore pris en charge.",
  "os.pay.page.reason.currency_mismatch": "La devise de l'établissement ne correspond pas à celle de son pays.",
  "os.pay.page.reason.country_not_available": "Les paiements par carte ne sont pas encore ouverts dans ce pays.",
  "os.pay.page.reason.provider_unavailable": "Le service de paiement est momentanément indisponible.",
  "os.pay.page.reason.generic": "Les paiements par carte ne sont pas disponibles pour cet établissement.",
  "os.pay.page.sub.title": "Abonnement professionnel",
  "os.pay.page.sub.note": "Votre abonnement Superkawa est distinct des paiements de vos clients.",
  "os.pay.page.sub.manage": "Gérer l'abonnement",
};
